'use client';

import { useTranslations } from 'next-intl';
import { Filter } from '@terra/ui-design-system';
import {
  isTraceResultFilter,
  type TraceResultFilter,
} from '../../../store/tab/tracesTabScopedFilterStore';
import { useSignalStatusFilterTranslations } from '../../../hooks/useSignalStatusFilterTranslations';

export function ExecutionsResultFilter({
  value,
  onChange,
}: {
  value: TraceResultFilter[];
  onChange: (value: TraceResultFilter[]) => void;
}) {
  const tExecutions = useTranslations('designSystem.executions');
  const { statusOptions, resolveStatusBadgeText } =
    useSignalStatusFilterTranslations();

  return (
    <Filter
      id="execution-result"
      density="compact"
      isMultiSelect
      placeholder={tExecutions('result')}
      items={statusOptions}
      value={value}
      contentWidth="320px"
      onChange={(values) => onChange(values.filter(isTraceResultFilter))}
      resolveBadgeText={resolveStatusBadgeText}
    />
  );
}
